exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.upload-box[data-v-2e4ea4b5] {\n  width: 100px;\n  height: 100px;\n}\n.upload-box .avatar-uploader-icon[data-v-2e4ea4b5] {\n    line-height: 100px;\n}\n.grade-setting-col[data-v-2e4ea4b5] {\n  line-height: 40px;\n}\n.btn-gap[data-v-2e4ea4b5] {\n  margin-left: 10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-2e4ea4b5","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/theme.scss","/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/_mixin.scss"]}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/view/mall/goods/attributes/category.vue
// module id = 1338
// module chunks = 0